import { useMutation, useQueryClient } from '@tanstack/react-query';
import ticketsService from '../services/ticketsService';
import { ticketsKeys } from '../queryKeys';

// El detalle (GET) y la cache usan `estado`/`agente` como ids, pero el backend
// (updateTicketSchema del PATCH) espera `estado_id`/`agente_id`; enviar los
// nombres de display haria que el body llegue sin campos reconocidos y el
// backend devuelva 400 "No hay campos para actualizar". Traducimos SOLO al
// construir el body: la actualizacion optimista (onMutate) sigue trabajando
// sobre la forma de la cache. El resto de campos (grupo_id, tema_id, prioridad,
// asunto) ya coinciden y pasan tal cual.
const CAMPO_A_BODY = { estado: 'estado_id', agente: 'agente_id' };
const aBodyPatch = (cambios) =>
  Object.fromEntries(
    Object.entries(cambios).map(([campo, valor]) => [CAMPO_A_BODY[campo] ?? campo, valor]),
  );

// PATCH /tickets/:id con actualizacion optimista del detalle. Tras resolver,
// invalida detalle + todas las listas + historial para reflejar campos
// derivados (actualizado_en, vence_sla_en) y el registro de auditoria.
const useActualizarTicket = (headquarter, id) => {
  const qc = useQueryClient();
  const keyDetalle = ticketsKeys.detalle(headquarter, id);

  return useMutation({
    mutationFn: (cambios) =>
      ticketsService.actualizarTicket({ headquarter, id, ...aBodyPatch(cambios) }),
    onMutate: async (cambios) => {
      await qc.cancelQueries({ queryKey: keyDetalle });
      const previo = qc.getQueryData(keyDetalle);
      if (previo) qc.setQueryData(keyDetalle, { ...previo, ...cambios });
      return { previo };
    },
    onError: (_err, _cambios, ctx) => {
      if (ctx?.previo) qc.setQueryData(keyDetalle, ctx.previo);
    },
    onSettled: () => {
      qc.invalidateQueries({ queryKey: keyDetalle });
      qc.invalidateQueries({ queryKey: ['tickets', 'lista'] });
      qc.invalidateQueries({ queryKey: ticketsKeys.historial(headquarter, id) });
    },
  });
};

export default useActualizarTicket;
